import { Flex, Heading, Icon, IconButton } from "@chakra-ui/react";
import { t } from "i18next";
import { useState } from "react";
import { FaArrowRight, FaClock, FaPlayCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useGetContractStatisticsQuery } from "../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { Stat } from "../../../common/Stat";
import { requireBooleanEnvVar } from "../../../config";
import { urls } from "../../../urls";
import { Invites } from "../../email-invites/manage-supplier-invites/Invites";
import { ContractStatusChart } from "./ContractStatusChart";

export const ContractStats = () => {
  const [showSendInvites, setShowSendInvites] = useState(false);
  const authState = useLoggedInWithOrgContextState();
  const navigate = useNavigate();

  const { data: contractStats, isLoading: isLoadingContractStats } = useGetContractStatisticsQuery({
    orgId: authState.selectedOrg.id,
    organizationId: authState.selectedOrg.id,
  });

  const contractsTableEnabled = requireBooleanEnvVar("VITE_ENABLE_CONTRACTS_TABLE");

  return (
    <>
      {showSendInvites && <Invites isOpen={true} onClose={() => setShowSendInvites(false)} />}
      {
        <>
          <Heading as="h2" fontSize={"sm"} color="smMuted" pb="4">
            {t("Contracts")}
          </Heading>
          {contractsTableEnabled && <ContractStatusChart />}
          {!isLoadingContractStats && contractStats && (
            <Flex columnGap="3" pb="4" pt="2.5">
              <Stat
                title={t("Active_plural")}
                values={[`${contractStats.numberOfActiveContracts} ${t("contracts")}`]}
                icon={<Icon as={FaPlayCircle} boxSize={8} color="smPrimary" />}
                color="smPrimary"
              />
              <Stat
                title={t("Expiring This Year")}
                values={[`${contractStats.numberOfContractsExpiringThisYear} ${t("contracts")}`]}
                icon={<Icon as={FaClock} boxSize={8} color="smWarning" />}
                color="smWarning"
              />
            </Flex>
          )}
          <IconButton
            aria-label="go to contracts"
            icon={<Icon as={FaArrowRight} />}
            variant={"link"}
            colorScheme="cyan"
            float="right"
            onClick={() => {
              navigate(`${urls.contracts.viewPublished}?status=Active,Awarded`);
            }}
          />
        </>
      }
    </>
  );
};
